module.exports = __webpack_public_path__ + "images/icons/boat-storage/10x40--boat-space.svg";